// src/components/AllianceSelector.js

import React, { useContext, useMemo } from 'react';
import { AuthContext } from '../context/AuthContext';

const AllianceSelector = ({ alliances, selectedAlliance, setSelectedAlliance }) => {
  const { user, isAuthenticated } = useContext(AuthContext);
  const sortedAlliances = useMemo(() => (
    [...(Array.isArray(alliances) ? alliances : [])].sort((left, right) => {
      const rightPower = Number(right?.battlePower || 0);
      const leftPower = Number(left?.battlePower || 0);
      if (rightPower !== leftPower) return rightPower - leftPower;
      return String(left?.name || '').localeCompare(String(right?.name || ''));
    })
  ), [alliances]);

  // If not authenticated or is a normal user, hide the selector
  if (!isAuthenticated() || user.role === 'user') {
    return null;
  }

  const handleAllianceChange = (e) => {
    const selectedAllianceId = e.target.value;
    const allianceObj = sortedAlliances.find((a) => a._id === selectedAllianceId);
    setSelectedAlliance(allianceObj);
  };

  // superUser or nationAdmin sees a dropdown to pick from `alliances`
  if (user.role === 'superUser' || user.role === 'nationAdmin' || user.role === 'supporter') {
    return (
      <div className="alliance-selector">
        <label htmlFor="alliance-select">Select Alliance:</label>
        <select
          id="alliance-select"
          value={selectedAlliance?._id || ''}
          onChange={handleAllianceChange}
        >
          <option value="">-- Select --</option>
          {sortedAlliances.map((alliance) => (
            <option key={alliance._id} value={alliance._id}>
              {alliance.name} ({alliance.acronym})
            </option>
          ))}
        </select>
      </div>
    );
  }

  // Fallback if some other role wants read-only display
  return (
    <div>
      <label>Alliance: {selectedAlliance?.name || ''}</label>
    </div>
  );
};

export default AllianceSelector;
